module.exports = __webpack_public_path__ + "Poppins-Light.3a7edf2f61eba7ba6b4d.woff2";


//////////////////
// WEBPACK FOOTER
// D:/a/1/s/src/assets/vendors/base/fonts/googleapi-fonts/Poppins-Light.woff2
// module id = ../../../../../src/assets/vendors/base/fonts/googleapi-fonts/Poppins-Light.woff2
// module chunks = styles